import React, { useMemo } from 'react';
import { PiDotsThreeVertical } from 'react-icons/pi';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import MenuDropdown from 'src/modules/shared/components/molecules/dropdowns/menu-dropdown';
import type { DropdownItem } from 'src/modules/shared/components/molecules/dropdowns/dropdown';

export interface IntegrationActionsMenuProps {
  items: DropdownItem[];
  disabled?: boolean;
  loading?: boolean;
  ariaLabel?: string;
}

export const IntegrationActionsMenu: React.FC<IntegrationActionsMenuProps> = ({
  items,
  disabled = false,
  loading = false,
  ariaLabel = 'Actions',
}) => {
  const nonNullItems = useMemo(
    () => items.filter((item) => item.content !== null),
    [items]
  );

  if (nonNullItems.length === 0) return null;

  return (
    <MenuDropdown
      items={nonNullItems}
      placement="bottom-end"
      disabled={disabled}
      isLoading={loading}
      handlerComponent={
        <Button
          type="button"
          variant="secondary"
          appearance="soft"
          size="md"
          isIconOnly
          aria-label={ariaLabel}
          disabled={disabled}
        >
          <PiDotsThreeVertical className="w-4 h-4" />
        </Button>
      }
    />
  );
};
